import { baseUrl } from 'authConfig';
import { getHeadersObject } from 'helpers/utils';
import { customFetch } from './customFetch';
import { Feature } from 'types/tenants';

export const getFeatures = async (token?: string): Promise<Feature[]> => {
  const res = await customFetch<Feature[]>(`${baseUrl}commondata/GetFeatures`, {
    method: 'GET',
    headers: getHeadersObject(token),
  });
  return res;
};
